<template>
  <div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
      <el-form-item :label="$t('marketing', 'couponName')" prop="name">
        <el-input class="w220" v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item :label="$t('marketing', 'minimumSpend')" prop="minAmount">
        <el-input class="w220" v-model="ruleForm.minAmount" type="number"></el-input>
        {{ $t('marketing', 'yuan') }}
      </el-form-item>
      <el-form-item :label="$t('marketing', 'couponType')" prop="couponType">
        <el-select v-model="ruleForm.couponType" :placeholder="$t('marketing', 'pleaseSelect')">
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('marketing', 'couponFaceValue')" prop="couponFaceValue" v-if="ruleForm.couponType == 1">
        <el-input
          type="number"
          :placeholder="$t('marketing', 'pleaseEnterCouponFaceValue')"
          v-model="ruleForm.couponFaceValue"
          class="input-with-select"
          style='width:300px'
        >
          <template slot="prepend">{{ $t('marketing', 'fullAmountReduction', { amount: ruleForm.minAmount }) }}</template>
          <template slot="append">{{ $t('marketing', 'yuan') }}</template>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('marketing', 'discount')" prop='couponDiscount' v-if="ruleForm.couponType == 2">
        <el-input-number
          :placeholder="$t('marketing', 'pleaseEnterDiscount')"
          v-model="ruleForm.couponDiscount"
          :min='1'
          :step='0.1'
          :max='9.99'
          class="input-with-select"
          style='width:220px'
        >
        </el-input-number>
        <span class="ml10">{{ $t('marketing', 'fold') }}</span>
      </el-form-item>
      <el-form-item :label="$t('marketing', 'useScope')" prop="rangeType">
        <el-radio
          class="mr10"
          style="margin: 0"
          v-model="ruleForm.rangeType"
          label="1"
          >{{ $t('marketing', 'universal') }}</el-radio
        >
        <el-radio v-model="ruleForm.rangeType" label="2">{{ $t('marketing', 'byCategory') }}</el-radio>
        <el-select
          style="width: 150px"
          :disabled='ruleForm.rangeType == 1'
          v-model="ruleForm.goodstypeId"
          :placeholder="$t('marketing', 'selectProductCategory')"
        >
          <el-option
            v-for="(item, index) in categoriesArr"
            :key="index"
            :label="item.name"
            :value="item.goodstypeId"
          >
          </el-option>
        </el-select>
        {{ $t('marketing', 'special') }}
      </el-form-item>
      <el-form-item :label="$t('marketing', 'distributionDate')" prop="grantTime">
        <el-date-picker
          v-model="ruleForm.grantTime"
          class="mr10"
          align="right"
          type="daterange"
          value-format="yyyy-MM-dd"
          :start-placeholder="$t('marketing', 'startDate')"
          :end-placeholder="$t('marketing', 'endDate')"
          :picker-options="pickerOptions"
        />
      </el-form-item>
      <el-form-item :label="$t('marketing', 'effectiveDate')" prop="effectiveDate">
        <el-date-picker
          v-model="ruleForm.effectiveDate"
          class="mr10"
          align="right"
          type="daterange"
          value-format="yyyy-MM-dd"
          :start-placeholder="$t('marketing', 'startDate')"
          :end-placeholder="$t('marketing', 'endDate')"
          :picker-options="pickerOptions"
        />
      </el-form-item>
      <el-form-item :label="$t('marketing', 'distributionMethod')" prop="grantMode">
        <el-radio v-model="ruleForm.grantMode" label="0"
          >{{ $t('marketing', 'newUserGift') }}</el-radio
        >
        <el-radio v-model="ruleForm.grantMode" label="1">{{ $t('marketing', 'homepageGift') }}</el-radio>
      </el-form-item>
      <el-form-item :label="$t('marketing', 'distributionQuantity')" prop="couponNum">
        <el-input
          class="w220"
          type="number"
          :placeholder="$t('marketing', 'pleaseEnterDistributionQuantity')"
          v-model="ruleForm.couponNum"
        />
        {{ $t('marketing', 'pieces') }}
      </el-form-item>
      <el-form-item :label="$t('marketing', 'maxPerUser')" prop="maxUser">
        <el-input
          class="w220"
          type="number"
          :placeholder="$t('marketing', 'pleaseEnter')"
          v-model="ruleForm.maxUser"
        />
        {{ $t('marketing', 'pieces') }}
      </el-form-item>
      <el-form-item :label="$t('marketing', 'distributionStatus')" prop="pubState">
        <el-switch
          v-model="ruleForm.pubState"
          :active-text="$t('marketing', 'enable')"
          :inactive-text="$t('marketing', 'disable')"
        >
        </el-switch>
      </el-form-item>
      <el-form-item :label="$t('marketing', 'remarks')" prop="note">
        <el-input
          type="textarea"
          class="w220"
          autosize
          :placeholder="$t('marketing', 'remarksContent')"
          v-model="ruleForm.note"
        >
        </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getGoodsTypeInfo } from '@/api/coupon';
import i18nMixin from '@/mixins/i18nMixin';

export default {
  name: "addCoupon",
  mixins: [i18nMixin],
  computed: {
    // 优惠券类型选项，响应语言变化
    options() {
      return [
        {
          label: this.$t('marketing', 'fullReductionCoupon'),
          value: "1",
        },
        {
          label: this.$t('marketing', 'discountCoupon'),
          value: "2",
        },
      ];
    },
  },
  data() {
    let scopeRules = (rule, value, callback) => {
      if(this.ruleForm.rangeType == 2 && this.ruleForm.goodstypeId == ''){
        callback(new Error(this.$t('marketing', 'pleaseSelectProductCategory')));
      }else {
        callback();
      }
    }
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      categoriesArr: [],
      ruleForm: {
        name: "",
        minAmount: "",
        couponFaceValue: "",
        couponDiscount:'',
        rangeType: "1",
        couponType: "",
        goodstypeId: '',
        grantTime: "",
        effectiveDate: "",
        grantMode: "0",
        couponNum: "",
        maxUser: "",
        pubState: false,
        note: "",
      },
      rules: {
        name:[
          { required: true, message: this.$t('marketing', 'pleaseEnterCouponName') }
        ],
        minAmount:[
          { required: true, message: this.$t('marketing', 'pleaseEnterMinimumSpend') }
        ],
        couponType:[
          { required: true, message: this.$t('marketing', 'pleaseSelectCouponType') }
        ],
        couponFaceValue:[
          { required: true, message: this.$t('marketing', 'pleaseEnterCouponFaceValue') }
        ],
        rangeType:[
          { validator: scopeRules, required: true }
        ],
        grantTime:[
          { required: true, message: this.$t('marketing', 'pleaseSelectDistributionDate') }
        ],
        effectiveDate:[
          { required: true, message: this.$t('marketing', 'pleaseSelectEffectiveDate') }
        ],
        grantMode:[
          { required: true, message: this.$t('marketing', 'pleaseSelectDistributionMethod') }
        ],
        couponNum:[
          { required: true, message: this.$t('marketing', 'pleaseEnterDistributionQuantity') }
        ],
        maxUser:[
          { required: true, message: this.$t('marketing', 'pleaseEnterMaxDistribution') }
        ],
        pubState:[
          { required: true, message: this.$t('marketing', 'pleaseSelectDistributionStatus') }
        ],
        couponDiscount:[
          { required: true, message: this.$t('marketing', 'pleaseEnterDiscount') }
        ],
      }
    };
  },
  props:{
    bEdit:{
      type:Boolean,
      default:false
    }
  },
  created(){
    this.getGoodsTypeInfo();
  },
  methods:{
    submitForm() {
      if(Number(this.ruleForm.minAmount) < Number(this.ruleForm.couponFaceValue)){
        return this.$message.error(this.$t('marketing', 'couponAmountCannotExceedMinimum'))
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if(this.bEdit){
            this.$emit("onConfirmEdit", this.ruleForm);
          }else{
            this.$emit("submitForm", this.ruleForm);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  async getGoodsTypeInfo(){
       const result = await getGoodsTypeInfo({ignore:true});
       this.categoriesArr = result.data;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
/deep/ input[type="number"] {
  -moz-appearance: textfield !important;
}
</style>
